module.exports = __webpack_public_path__ + "img/img_46@2x.94d54ad6.png";